import { useFormik } from "formik";
import moment from "moment";
import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import TextInput from "../common/textfield/TextInput";
import { addManualReadingForPatient } from "../api/VitalObservation";
import { failed, success } from "../common/Toastify";
import { Button } from "../common/Button";
import * as Yup from 'yup';

const WeightModal = ({ weightModalShow, weightModalClose, units, programId }) => {
    const storedProfile = sessionStorage.getItem("relatedPersonProfile");
    const storedId = storedProfile ? JSON.parse(storedProfile).id : null;

    const patientId = useSelector((state) => storedId || state?.auth?.user?.["custom:unique_id"]);

    //const patientId = useSelector((state) => state?.auth?.user?.["custom:unique_id"]);
    const [btnLoading, setBtnLoading] = useState(false);
    const currentDate = moment(new Date()).format('MM/DD/YYYY');

    const formik = useFormik({
        initialValues: {
            weight: ""
        },
        validationSchema: Yup.object({
            weight: Yup.number()
                .typeError("Must be a number")
                .min(0, "Must be greater than or equal to 0")
                .max(500, "Must be less than or equal to 999")
                .test(
                    "decimal-places",
                    "Only one decimal places are allowed",
                    value => (value + "").match(/^\d+(\.\d{0,1})?$/)
                )
                .required("Weight is required"),
        }),
        onSubmit: (values) => {
            setBtnLoading(true);
            let params = {
                patientId: patientId,
                programId: programId,
                effectiveDateTime: currentDate,
                conditionName: "weight",
                valueQuantity: {
                    value: {
                        weight: values.weight
                    },
                    unit: {
                        weight: units.weight
                    },
                },
                device: {
                    reference: 'Device/null',
                }
            };

            addManualReadingForPatient(params)
                .then((res) => success(res?.message))
                .catch((error) => failed(error))
                .finally(() => {
                    setBtnLoading(false);
                    weightModalClose();
                })
        }
    })

    return (
        <Modal
            backdropClassName
            backdrop={'static'}
            show={weightModalShow} onHide={weightModalClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered className="custom-dialog">

            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">Weight Reading</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    <Row>
                        <Col>
                            <TextInput keyField={"weight"} formik={formik} label={`Weight (${units.weight})`} placeholder={"Enter here..."} readOnly={false} disabled={false} required={true} />
                        </Col>
                    </Row>

                    <div className="btn-wrap">
                        <Button
                            onClick={() => {
                                weightModalClose();
                            }}
                            variant="secondary"
                            title="Cancel"
                        >
                            Cancel
                        </Button>
                        <Button type="submit" isLoading={btnLoading}>
                            Add
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
};

export default WeightModal;